import { palette } from "../theme/palette";

export const SHOW_ORDER_DATE_FORMAT = 'MMM D, YYYY'; //Example Aug 22, 2024

export enum PART_ASSIGNMENT_KEYS {
  ID = 'part_id',
  PART_NUMBER = 'part_information.part_number',
  PART_LENGTH = 'part_assignments.length',
  PART_PROVIDER_NAME = 'part_information.provider_name',
  PART_CLASS_DESCRIPTION = 'part_information.part_class_description',
}

export const ORDER_CONFIRMED = 'ORDER CONFIRMED';
export const ORDER_CANCELED = 'ORDER CANCELED';
export const REQUEST_SUBMITTED = 'REQUEST SUBMITTED';

const ORDER_CONFIRMED_IDS = [1, 2, 3, 4, 5, 6, 7, 9];
const ORDER_CANCELED_IDS = [8];
const REQUEST_SUBMITTED_IDS = [10];

export const ORDER_STATUS_BACKGROUND_COLOR: Record<number, string> = {};
ORDER_CONFIRMED_IDS.forEach(id => ORDER_STATUS_BACKGROUND_COLOR[id] = palette.orderStatusBackgroundColors.order_confirmed);
ORDER_CANCELED_IDS.forEach(id => ORDER_STATUS_BACKGROUND_COLOR[id] = palette.orderStatusBackgroundColors.order_canceled);
REQUEST_SUBMITTED_IDS.forEach(id => ORDER_STATUS_BACKGROUND_COLOR[id] = palette.orderStatusBackgroundColors.request_submitted);

export const ORDER_STATUS_ID_TO_STATUS_MAP: Record<number, string> = {};
ORDER_CONFIRMED_IDS.forEach(id => ORDER_STATUS_ID_TO_STATUS_MAP[id] = ORDER_CONFIRMED);
ORDER_CANCELED_IDS.forEach(id => ORDER_STATUS_ID_TO_STATUS_MAP[id] = ORDER_CANCELED);
REQUEST_SUBMITTED_IDS.forEach(id => ORDER_STATUS_ID_TO_STATUS_MAP[id] = REQUEST_SUBMITTED);